export const CDN_URL = "https://static.luckypost.cn";
export const CDN_UPLOAD_URL = `${CDN_URL}/upload/`;

const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z\d+.-]*:|\/\/|#)/i;
const IMAGE_SRC_PATTERN = /(<img\b[^>]*\bsrc\s*=\s*)(["'])(.*?)\2/gi;

const normalizeCdnDomain = (domain = CDN_URL) => String(domain || "").replace(/\/+$/, "");

export const toCdnUrl = (value, domain = CDN_URL) => {
  const url = String(value || "").trim();
  if (!url || ABSOLUTE_URL_PATTERN.test(url)) return url;

  return `${normalizeCdnDomain(domain)}/${url.replace(/^\/+/, "")}`;
};

export const prependCdnDomainToRichTextImages = (html, domain = CDN_URL) => {
  if (!html) return "";

  return String(html).replace(IMAGE_SRC_PATTERN, (match, prefix, quote, src) => {
    const displayUrl = toCdnUrl(src, domain);
    return `${prefix}${quote}${displayUrl}${quote}`;
  });
};

export const stripCdnDomainFromRichTextImages = (html, domain = CDN_URL) => {
  if (!html) return "";

  const cdnDomain = normalizeCdnDomain(domain);
  return String(html).replace(IMAGE_SRC_PATTERN, (match, prefix, quote, src) => {
    const trimmedSrc = String(src || "").trim();
    let storedUrl = trimmedSrc;

    if (trimmedSrc === cdnDomain) {
      storedUrl = "/";
    } else if (trimmedSrc.startsWith(`${cdnDomain}/`)) {
      storedUrl = trimmedSrc.slice(cdnDomain.length);
    } else if (trimmedSrc && !ABSOLUTE_URL_PATTERN.test(trimmedSrc)) {
      storedUrl = `/${trimmedSrc.replace(/^\/+/, "")}`;
    }

    return `${prefix}${quote}${storedUrl}${quote}`;
  });
};
